<template>
  <Teleport to="body">
    <dialog
      class="modal"
      v-bind="attrs"
      open
      @keyup.esc="close"
      @mousedown="onBackdropClick"
    >
      <div
        class="modal-content"
        :class="modalWidth"
      >
        <header class="modal-header">
          <slot name="title">
            <h3>{{ title }}</h3>
          </slot>

          <button
            type="button"
            class="cursor-pointer text-2xl text-white"
            @click="$emit('close')"
          >
            <i class="fa-regular fa-circle-xmark" />
          </button>

          <span class="sr-only">Close modal</span>
        </header>

        <section
          v-if="$slots.body"
          class="modal-body"
        >
          <slot name="body" />
        </section>

        <section
          v-if="$slots.footer"
          class="modal-footer"
        >
          <slot name="footer" />
        </section>
      </div>
    </dialog>
  </Teleport>
</template>

<script setup>
import { useAttrs, computed } from 'vue';

// bind attrs to dialog instead of having teleport auto-inherit them
defineOptions({ inheritAttrs: false });
const attrs = useAttrs();

const props = defineProps({
  disabled: Boolean,
  title: String,
  size: {
    type: String,
    default: '5xl',
  },
  disableBackdropClick: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close']);

const close = () => {
  if (!props.disabled) {
    emit('close');
  }
};

const onBackdropClick = e => {
  if (props.disableBackdropClick) return;

  if (e.target.classList.contains('modal')) {
    close();
  }
};

const modalWidth = computed(() => {
  return `max-w-${props.size}`;
});
</script>
